import { Translations } from "@shared/i18n/TranslationsEnum";

const fr = {
  [Translations.Common]: {
    "errors": {
      "noProjectSelected": "Aucun projet n'est sélectionné",
      "noHubSelected": "Aucun hub n'est sélectionné"
    },
    "actions": {
      "cancel": "Annuler",
      "close": "Fermer",
      "retry": "Réessayer"
    },
    "searchField": {
      "placeholder": "Chercher dans les fichiers"
    },
    "fileActions": {
      "upload": {
        "emptyFileUploadError": "Vous ne pouvez téléverser un fichier vide",
      },
      "get": {
        "error": "Une erreur est survenue lors du chargement des fichiers"
      }
    },
    "secondaryFileActions": {
      "get": {
        "error": "Une erreur est survenue lors du chargement des fichiers secondaires"
      },
    },
    "folderActions": {
      "get": {
        "error": "Une erreur est survenue lors du chargement de la structure des dossiers"
      }
    },
    "folderTree": {
      "rootNodeName": "Fichiers",
      "emptyTree": {
        "title": "Aucun dossier",
        "action": "Créer un dossier"
      }
    },
    "edms": {
      "connectorList": {
        "expiredTokens": {
          "title": "Authentification expirée",
          "subTitle": "Reconnectez-vous à votre source de données afin d'y avoir accès",
          "action": "Se connecter"
        },
        "resourceNotFound": {
          "title": "Le dossier que vous avez lié n’est plus disponible",
          "subTitle": "Il semble qu’il a été supprimé ou déplacé",
          "bannerTitle": "Le dossier lié n’est plus disponible"
        }
      },
      "linkedFolder": {
        "get": {
          "error": "Une erreur s'est produite lors du chargement de vos fichiers. Veuillez réessayer."
        },
        "error": {
          "refreshPage": "Actualiser la page"
        }
      }
    },
    [Translations.ForbiddenAccess]: {
      "header": "Vous n'avez pas accès au gestionnaire de fichiers",
      "body": "Si vous avez besoin d'accéder au gestionnaire de fichiers, demandez-le à l'administrateur de votre projet"
    },
    [Translations.HubExpired]: {
      "header": "L'abonnement du hub est expiré",
      "body": "Veuillez mettre à jour votre abonnement"
    }
  },
};

export default fr;